import * as React from 'react'
import { PieChart, Pie, Sector, Cell, ResponsiveContainer, Legend } from 'recharts'

// const data = [
//   { name: 'device_cnt', value: 3 },
//   { name: 'total_device_cnt', value: 5 },
// ]

// {device_cnt: 1, total_device_cnt: 6}

const COLORS = ['url(#colorUv)', '#2B2B36']
export default function PieGraph({ param }) {
  // console.log('PieGraph param:', param)
  let result = []
  if (param !== undefined) {
    const tempData = param
    let nameTemp = Object.keys(tempData)
    let valueTemp = Object.values(tempData)

    // console.log('PieGraph name:', nameTemp)
    // console.log('PieGraph value:', valueTemp)

    nameTemp.map((item, index) => {
      if (index === 0) {
        const conObject = {
          name: nameTemp[index],
          value: valueTemp[0] / valueTemp[1],
        }
        result.push(conObject)
      }
      if (index === 1) {
        const conObject = {
          name: nameTemp[index],
          value: (valueTemp[1] / valueTemp[1]) - (valueTemp[0] / valueTemp[1]),
        }
        result.push(conObject)
      }
    })
  }

  // `${Math.floor((item5Data.device_cnt / item5Data.total_device_cnt) * 100)}%`
  return (
    <ResponsiveContainer width="100%" height={180}>
      <PieChart>
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="100%" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#628EFF" />
            <stop offset=".6" stopColor="#8740CD" />
            <stop offset="1" stopColor="#580475" />
          </linearGradient>
        </defs>
        <Pie
          data={result}
          startAngle={180}
          endAngle={0}
          innerRadius={60}
          outerRadius={80}
          fill="url(#colorUv)"
          dataKey="value"
        >
          {result.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  )
}
